import React, {
  FC,
  ReactNode,
  useEffect,
  useRef,
} from 'react';
import { Dropdown } from 'react-bootstrap';
import app from 'srcJs/App';
import { useUserData } from 'components/user/hooks/use-user-data';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import classNames from 'classnames';
import { When } from 'react-if';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import { Badge } from 'ui/badge/Badge';

type PropsType = {
  isOpen: boolean;
};

const DropdownToggle: FC<PropsType> = ({
  isOpen,
}) => {
  const userData = useUserData();
  const refPopover = useRef();

  useEffect(() => {
    // @ts-ignore
    refPopover.current?.hide();
  }, [isOpen]);

  const renderBalance = (): ReactNode => {
    if (!userData.balanceData.hasCreditLimit) {
      return (
        <span className="font-weight-bold">
          {userData.balanceData.valueFormat}
        </span>
      );
    }

    return (
      <PopoverStickOnHover
        text={userData.balanceData.tooltip}
        asHtml
        placement="bottom"
        popoverProps={{
          bsPrefix: 'popover popover_full-width',
        }}
        ref={refPopover}
      >
        <span
          className={classNames(
            'font-weight-bold',
            { 'text-danger': userData.balanceData.isNegative },
          )}
        >
          {userData.balanceData.valueFormat}
        </span>
      </PopoverStickOnHover>
    );
  };

  return (
    <Dropdown.Toggle
      variant="link"
      id="dropdown-balance-button"
      className="d-flex text-reset text-h-primary text-decoration-none px-0"
    >
      <span className="fs-12 color-858585 mr-8p">
        {app.tForReact('base', 'Balance')}
      </span>
      {renderBalance()}
      <When condition={userData.invoiceNotify}>
        <Badge variant={Variant.warning} pill additionalClassName="text-white ml-1">
          {userData.invoiceNotify}
        </Badge>
      </When>
    </Dropdown.Toggle>
  );
};

export { DropdownToggle };
